import { axiosConfigToUploadBase } from "../../config/api/configApiUploadFile";
import {axiosConfigV2} from "../../config/api/configApiv2";
import {AxiosResponse} from "axios";

export const getQuizVersionDetails: (data: any) => Promise<AxiosResponse<any>> = (data = {}) => {
  return axiosConfigV2.post(`/question-bank/get-quiz-version-details-in-question-bank`, data);
};
export const getQuizInUseInfo: (data: any) => Promise<AxiosResponse<any>> = (data) => {
  return axiosConfigV2.post(`/question-bank/get-quiz-in-use-info`, data);
};

export const getVersionsOfQuiz: (
  quizId: number
) => Promise<AxiosResponse<any>> = (quizId) => {
  return axiosConfigToUploadBase.get(
    `/v2/api/question-bank/get-versions-of-quiz-in-question-bank/${quizId}`
  );
};